import React, {useState, useEffect} from 'react';
import {NavLink, BrowserRouter as  Router,Route, Routes} from "react-router-dom";
import { Menu } from 'react-feather';
import SidebarMenu from './SidebarMenu';
import Dashboard from '../components/SideMenu/Pages/Dashboard';
import ViewReviews from '../components/SideMenu/Pages/ViewReviews';
import InsertReviews from '../components/SideMenu/Pages/InsertReviews';
//import EditReviews from '../components/SideMenu/Pages/EditReviews';
import UserSettings from '../components/SideMenu/Pages/UserSettings';
import EditUserSettings from '../components/SideMenu/Pages/EditUserSettings';
import UserNewEntry from '../components/SideMenu/Pages/UserNewEntry';
import EmployeeList from '../components/SideMenu/Pages/EmployeeList';
import RichTextEditor from '../components/SideMenu/Pages/RichTextEditor';
import '../css/style.css';
import Loading from '../components/SideMenu/components/Loading';
import StudentList from '../components/SideMenu/Pages/StudentList';
//import { useParams } from 'react-router-dom';
import ViewProfile from '../components/SideMenu/Pages/ViewProfile';
import { fetchUser } from '../config/UserDetailsPrimary';
//import Navigation from '../components/SideMenu/components/Navigation';
//import PrintProfile from '../components/SideMenu/components/PrintProfile';
//import PDFGenerate2 from '../components/SideMenu/components/PDFGenerate2';
//import PrintProfile from '../components/SideMenu/components/PrintProfile';
//import GeneratePDF from '../components/PDF/GeneratePDF';
//import PDFViewerComponent from '../components/PDF/PDFViewerComponent';
//import PrintButton from '../components/PDF/CreatePDF';
import PowerPointEditor from '../components/SideMenu/Pages/PowerPointEditor';
import CreateQuizPage from '../Pages/CreateQuizPage';
import TakeQuizPage from '../Pages/TakeQuizPage';
import QuizDashboard from '../Pages/Dashboard';



const Home = ({ user }) => {
//  const { ids } = useParams();

  const [isMobileMenuVisible, setMobileMenuVisible] = useState(false);

  const [userDetails, setUserDetails] = useState(null);
  const [method, setMethod] = useState('insert');

  const [isLoading, setIsLoading] = useState(true); 

  const userStudent = 'Student';
  const userEmployee = 'Employee';

 //const [currentUser, setCurrentUser] = useState(user ?? JSON.parse(sessionStorage.getItem("user") || '{"email": ""}'));

const currentUser = JSON.parse(sessionStorage.getItem("user"));
 


  const handleMobileMenuClick = (e) => {
    e.preventDefault();
    setMobileMenuVisible(!isMobileMenuVisible);
   
  };

  

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const data = await fetchUser(currentUser); // Fetch user data
        if (data && data.length > 0) {
          setUserDetails(data[0]); // Set userDetails state
          setMethod('update')
          console.log('data id:', user);
        } else {
          console.log('No data found for id:', user);
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
    console.log('data found :', userDetails);
    console.log('emmmmm :', currentUser);
    console.log('local : ',localStorage);
  }, [user]);


  useEffect(() => {
    // Simulating loading completion after 3 seconds
    const loadingTimer = setTimeout(() => {
      setIsLoading(false); // Simulating loading completion
    }, 3000);

    // Clear the timer to avoid memory leaks
    return () => clearTimeout(loadingTimer);
  }, []);

  console.log('Userrrr :',user)
  
  

  return (
    
    <Router>
      
      <div className={`body ${isMobileMenuVisible? 'sidebar-show' : ''}`} >
    <div className='skin-base animate' >
    <SidebarMenu user={currentUser} setIsLoading={setIsLoading}/>
    <div className="content">
    <div className="content-header" >
      
      <NavLink onClick={handleMobileMenuClick}  className="content-menu d-lg-none"><Menu /></NavLink>
    </div>

    <div className="content-body">
    <div>
      {isLoading ? (
        <Loading size={100}/> // Display loading component if isLoading is true
      ) : (
        
    <Routes>
    <Route path="/" element={<Dashboard />} />
    <Route path="/view-reviews" element={<ViewReviews />} />
    <Route path="/insert-reviews" element={<InsertReviews />} />
    <Route path="/edit/:id" element={<InsertReviews />} />
    <Route path="/text-editor" element={<RichTextEditor />} />
    <Route path="/user-settings" element={<UserSettings user={user} />} />
    <Route path="/user-settings/edit" element={<EditUserSettings user={user} />} />
    <Route path="/students/edit-profile/:postId" element={<UserNewEntry user={user} />} />
    <Route path="/employee/edit-profile/:postId" element={<UserNewEntry user={user} />} />
    <Route path="/students/new-entry" element={<UserNewEntry user={user} userCon={userStudent} />} />
    <Route path="/employee/new-entry" element={<UserNewEntry user={user} userCon={userEmployee} />} />
    <Route path="/students/list" element={<StudentList />}  />
    <Route path="/students/view-profile/:postId" element={<ViewProfile user={user} />}  />
    <Route path="/employee/view-profile/:postId" element={<ViewProfile user={user} />}  />
    <Route path="/employee/list" element={<EmployeeList />}  /> 
    <Route path="/powerpoint-editor" element={<PowerPointEditor />} />
    <Route path="/quiz" element={<QuizDashboard />} />
    <Route path="/create_quiz" element={<CreateQuizPage />} />
    <Route path="/quiz/:id" element={<TakeQuizPage />} />
    

    

    

    

    </Routes>
   
    )}
    </div>
    </div>
  </div>
  </div>
  </div>
  
    </Router>
  

  );
};

export default Home;
